// directive

var moduleName = 'yelpSubscription';
var mod = angular.module(moduleName, [])
  .config(function($stateProvider) {

    $stateProvider
      .state('yelpSubscription', {
        url: '/yelpSubscription',
        template: require('./yelpSubscription.html'),
        controller: 'yelpSubscriptionCtrl'
      })
  });

require('./yelpSubscriptionCtrl').default(mod);

module.exports = moduleName;
